function toHoursLabel(hour, isVerbose) {
    if (isVerbose === true) {
        return toLongHoursLabel(hour);
    }
    return '' + hour + 'h';
}

function toLongHoursLabel(hours) {
    if (hours === 1) {
        return '' + hours + ' hour'
    } else {
        return '' + hours + ' hours'
    }
}

function toLongHoursLabelWithRange(min, max) {
    if (min === max) {
        return toLongHoursLabel(min);
    }
    return '' + min + ' - ' + max + ' hours';
}

function toDaysLabel(days, verbose) {
    if (verbose === true) {
        return toLongDaysLabel(days);
    }
    return '' + days + 'd';
}

function toLongDaysLabel(days) {
    if (days === 1) {
        return '' + days + ' day'
    } else {
        return '' + days + ' days'
    }
}

function toMinsHoursLabel(mins, verbose) {
    if (mins < 60) {
        if (verbose === true) {
            return '' + mins + ' minutes';
        }

        return '' + mins + 'min';
    }
    let mins_in_hour = mins % 60;
    let hours = (mins - mins_in_hour) / 60;
    if (mins_in_hour === 0) {
        if (verbose === true) {
            return toLongHoursLabel(hours);
        }

        return '' + hours + 'h';
    }

    if (verbose === true) {
        return '' + hours + ' hours, ' + mins_in_hour + ' minutes';
    }

    return '' + hours + 'h ' + mins_in_hour + 'mins';
}

function toTimeOfDayLabel(hour) {
    if (hour === 0 || hour === 24) {
        return '12 am';
    }
    if (hour === 12) {
        return '12 pm';
    }
    if (hour < 12) {
        return '' + hour + ' am';
    }
    if (hour < 24) {
        return '' + (hour - 12) + ' pm';
    }
    return '' + (hour - 24) + ' am';
}

function toTimeOfDayLabelWithMin(mins) {
    let minOfHour = mins % 60;
    let hour = (mins - minOfHour) / 60;
    let displayHour = hour;
    let indicator = ' am';
    let keepAm = false;
    if (displayHour > 23) {
        displayHour -= 24;
        keepAm = true;
        if (displayHour === 0) {
            displayHour = 12;
        }
    }
    if (displayHour > 11) {
        displayHour -= 12;
        if (displayHour === 0) {
            displayHour = 12;
        }
        if (!keepAm) {
            indicator = ' pm';
        }
    }
    if(displayHour === 0) {
        displayHour = 12;
        indicator = ' am';
    }
    let displayMin = '' + minOfHour;
    if (minOfHour < 10) {
        displayMin = '0' + minOfHour;
    }
    return '' + displayHour + ':' + displayMin + indicator
}

function toDayOfWeekLabel(day) {
    switch (day) {
        case 1:
            return 'Mon';
        case 2:
            return 'Tue';
        case 3:
            return 'Wed';
        case 4:
            return 'Thu';
        case 5:
            return 'Fri';
        case 6:
            return 'Sat';
        case 7:
            return 'Sun';
    }
    return '?';
}


function toLongDayOfWeekLabel(day) {
    switch (day) {
        case 1:
            return 'Monday';
        case 2:
            return 'Tuesday';
        case 3:
            return 'Wednesday';
        case 4:
            return 'Thursday';
        case 5:
            return 'Friday';
        case 6:
            return 'Saturday';
        case 7:
            return 'Sunday';
    }
    return '?';
}

function toMinutes(hrs, mins) {
    return hrs*60+mins;
}

function toDateStr(year, month ,day) {
    return year + '-'+(month < 10 ? '0' + month : month) + '-'+ (day < 10 ? '0' + day : day);
}


let monthNames = [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
];

let monthNamesShort = [
    "Jan", "Feb", "Mar",
    "Apr", "May", "Jun", "Jul",
    "Aug", "Sep", "Oct",
    "Nov", "Dec"
];

function dateToStringMY(date) {
    let monthIndex = date.getMonth();
    let year = date.getFullYear();

    return '' + monthNames[monthIndex] + ' ' + year;
}


function dateToStringM(date) {
    let monthIndex = date.getMonth();

    return '' + monthNames[monthIndex];
}

function dateToStringDM(date) {
    let monthIndex = date.getMonth();
    let day = date.getDate();
    let dayMod = day % 10;
    let dayPostfix = dayMod === 1 ? 'st' : dayMod === 2 ? 'nd' : dayMod === 3 ? 'rd' : 'th';

    return '' + day + dayPostfix + ' ' + monthNamesShort[monthIndex];
}

function dateToStringDMY(date) {
    let monthIndex = date.getMonth();
    let day = date.getDate();
    let year = date.getFullYear();

    let dayMod = day % 10;
    let dayPostfix = dayMod === 1 ? 'st' : dayMod === 2 ? 'nd' : dayMod === 3 ? 'rd' : 'th';

    return '' + day + dayPostfix + ' ' + monthNames[monthIndex] + ' ' + year;
}

function monthsBetween(date1, date2) {
    let months1 = date1.getMonth() + (date1.getFullYear() * 12);
    let months2 = date2.getMonth() + (date2.getFullYear() * 12);
    let diff = months2 - months1;
    return diff > 0 ? diff : 0;
}
